import { AfterViewInit, Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-geographic-map',
  templateUrl: './geographic-map.component.html',
  styleUrls: ['./geographic-map.component.scss']
})
export class GeographicMapComponent {
  tab = 0;
  constructor(
    private companyService: CompanyService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {

  }

}
